{
  "$comment": "Yofis — построение буквенного аватара (инициалов) из названия чата или имени человека. Один алгоритм для веба, десктопа и Kotlin/Swift: берётся кодом, проверяется сборкой на корпусе. Появился после находки сессии «Логотип»: «ООО «Кубик» · партнёр» давало аватар «О«» — первую букву и кавычку.",
  "meta": { "version": "1.0.0", "owner": "Дизайн Йофис", "created": "2026-09-23" },

  "algorithm": [
    "0. Если строка — адрес (есть @), взять часть до собаки: домен к человеку отношения не имеет.",
    "1. Убрать из строки всё, что не буква, не цифра и не разделитель: кавычки любых видов («» \" ' ‘ ’ “ ”), скобки, точки, запятые, двоеточия, символы · — и эмодзи.",
    "2. Разбить на слова по пробелам и дефисам (дефис — разделитель: «IT-поддержка» это два слова).",
    "3. Выбросить служебные слова из списка skip (организационные формы), но только если после этого хоть одно слово осталось.",
    "4. Если слов ≥ 2 — взять первые буквы первых двух слов.",
    "5. Если слово одно — взять его первые две буквы.",
    "6. Если не осталось ничего (название из одних знаков или эмодзи) — показать запасной символ.",
    "7. Привести к верхнему регистру; если получилась одна буква — оставить одну, не дополнять."
  ],

  "skip": ["ООО", "ЗАО", "ОАО", "ПАО", "АО", "ИП", "НКО", "ФГУП", "МУП", "LLC", "LTD", "INC", "GMBH"],
  "fallback": "#",
  "max_chars": 2,

  "corpus": [
    { "in": "ООО «Кубик» · партнёр", "out": "КП", "why": "кавычки не буквы; ООО — служебное слово" },
    { "in": "IT-поддержка", "out": "IП", "why": "дефис — разделитель, два слова" },
    { "in": "Отдел продаж", "out": "ОП", "why": "обычный случай" },
    { "in": "Бухгалтерия", "out": "БУ", "why": "одно слово — две первые буквы" },
    { "in": "Марина Ковалёва", "out": "МК", "why": "имя и фамилия" },
    { "in": "  Анонсы   компании  ", "out": "АК", "why": "лишние пробелы не мешают" },
    { "in": "«Смета Кубик»", "out": "СК", "why": "кавычки вокруг всего названия" },
    { "in": "ЗАО \"Ромашка\"", "out": "РО", "why": "прямые кавычки, служебное слово, одно значимое слово" },
    { "in": "Q4", "out": "Q4", "why": "цифры допускаются" },
    { "in": "🎉", "out": "#", "why": "из одних эмодзи — запасной символ" },
    { "in": "ООО", "out": "ОО", "why": "служебное слово выбрасывается только если что-то останется" },
    { "in": "Координация внедрения и сопровождения", "out": "КВ", "why": "длинное название — первые два слова" },
    { "in": "ivan@company.ru", "out": "IV", "why": "адрес вместо имени: берём localpart, иначе выйдет «IC» — Ivan Company" },
    { "in": "Пётр", "out": "ПЁ", "why": "буква ё сохраняется" }
  ],

  "source": {
    "$comment": "Откуда брать строку для инициалов. Найдено на живом клиенте: свой аватар строился из адреса, и у «Светланы Кузнецовой» с логином sveta выходило «SV» — латиница вместо собственных инициалов.",
    "order": ["display_name", "chat.title", "address"],
    "rule": "Адрес — последнее средство, когда имени нет вовсе (гость без имени, удалённая запись). Для своего аватара адрес не используется никогда: имя у себя известно всегда."
  },

  "forbidden": [
    "Брать первые символы строки без очистки: даёт «О«» на «ООО «Кубик»».",
    "Разбивать только по пробелу: «IT-поддержка» даёт одну букву.",
    "Дополнять одну букву точкой или дефисом («О.») — это читается как ошибка.",
    "Показывать пустой кружок: если букв нет вовсе, ставим запасной символ.",
    "Строить свой аватар из адреса: у «Светланы Кузнецовой» с логином sveta выходит «SV» — латиница вместо собственных инициалов."
  ]
}
